import {useCallback, useMemo, useState} from "react";
import {useSiren} from "../SirenContext";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "./useNavigateWithClientID";

export function useCreateContact() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneMobileWork, setPhoneMobileWork] = useState<string>();
    const [phoneMobilePersonal, setPhoneMobilePersonal] = useState<string>();
    const [phoneHome, setPhoneHome] = useState<string>();
    const [emailWork, setEmailWork] = useState("");
    const [emailPersonal, setEmailPersonal] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const {clientID, setToast} = useSiren();
    const {navigateWithClientID} = useNavigateWithClientID();

    const request = useMemo(() => ({
        firstName, lastName, phoneMobileWork, phoneMobilePersonal, phoneHome, emailWork, emailPersonal, clientID,
    }), [firstName, lastName, phoneMobileWork, phoneMobilePersonal, phoneHome, emailWork, emailPersonal, clientID]);

    const submit = useCallback(async () => {
        setIsLoading(true);
        try {
            await platformAPI.post("api/contacts", request);
            setToast("Contact created", "success");
            navigateWithClientID("/siren/contacts");
        } finally {
            setIsLoading(false);
        }
    }, [request]);

    return {
        firstName, setFirstName,
        lastName, setLastName,
        phoneMobileWork, setPhoneMobileWork,
        phoneMobilePersonal, setPhoneMobilePersonal,
        phoneHome, setPhoneHome,
        emailWork, setEmailWork,
        emailPersonal, setEmailPersonal,
        isLoading,
        submit,
    };
}
